import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    contactId: Number,
    contactType: { type: String, default: "Contact" },
    phoneNumber: String,
    logUrl: String
  }

  call(event) {
    event.preventDefault()
    this.logActivity()
    window.location.href = `tel:${this.phoneNumberValue}`
  }

  logActivity() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (!this.logUrlValue || !token) return

    fetch(this.logUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({
        activitable_type: this.contactTypeValue,
        activitable_id: this.contactIdValue,
        phone_number: this.phoneNumberValue
      })
    })
  }
}
